<app-breadcrumb *ngIf="!disableBreadcrumb" [parentName]="'Newsletter'" [name]="'Historia'"></app-breadcrumb>
<div class="newsletter-list-container">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="newsletter-list-filters">
        <mat-form-field class="newsletter-list-filter">
            <mat-label>Nazwa</mat-label>
            <input matInput placeholder="Nazwa" name="contains$newsletterName" [(ngModel)]="initialFilters.contains$newsletterName">
        </mat-form-field>

      <app-datepicker
        class="newsletter-list-filter"
        label="Data dodania od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
      ></app-datepicker>
      <app-datepicker
        class="newsletter-list-filter"
        label="Data datania do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      ></app-datepicker>
    </form>

    <div class="newsletter-list-buttons">
<!--        <button (click)="downloadReport()" [disabled]="!(userPermissions | async).contract.read_report"-->
<!--                mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
        <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
        <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>

    <table mat-table [dataSource]="newsletters">

      <ng-container matColumnDef="nr">
        <th mat-header-cell *matHeaderCellDef> Nr</th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" (click)="viewNewsletter(element)">{{element.id}}</a>
        </td>
      </ng-container>

        <!-- Position Column -->
        <ng-container matColumnDef="newsName">
            <th mat-header-cell *matHeaderCellDef> Nawa</th>
            <td mat-cell *matCellDef="let element">
              <a class="default-link" (click)="viewNewsletter(element)">{{element.newsletterName}}</a>
            </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef> Data dodania</th>
            <td mat-cell *matCellDef="let element">
                {{element.createdAt | date:'y-MM-dd'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <div fxLayout="row">
              <button [disabled]="!(userPermissions | async)?.newsletter.write"
                      [routerLink]="['/newsletter/szczegoly', element.uuid]"
                      mat-menu-item
                      (click)="editNewsletter(element)">Edytuj</button>
              <button *ngIf="(userPermissions | async)?.newsletter.delete"
                      [disabled]="!(userPermissions | async)?.newsletter.delete"
                      mat-menu-item
                      (click)="deleteNewsletter(element)"
                      color="warn">
                <span class="mat-menu-item-delete">Usuń</span>
              </button>
              </div>
            </td>
        </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
<!--          <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="(userPermissions | async)?.newsletter.write"><mat-icon>expand_more</mat-icon></button>-->
<!--          <mat-menu #menu="matMenu" xPosition="before">-->
<!--            <button [disabled]="!(userPermissions | async)?.newsletter.write"-->
<!--                    [routerLink]="['/newsletter/szczegoly', element.uuid]"-->
<!--                    mat-menu-item-->
<!--                    (click)="editNewsletter(element)">Edytuj</button>-->
<!--            <button *ngIf="(userPermissions | async)?.newsletter.delete"-->
<!--                    [disabled]="!(userPermissions | async)?.newsletter.delete"-->
<!--                    mat-menu-item-->
<!--                    (click)="deleteNewsletter(element)"-->
<!--                    color="warn">-->
<!--              <span class="mat-menu-item-delete">Usuń</span>-->
<!--            </button>-->
<!--          </mat-menu>-->
          <div class="newsletter-list-buttons-td">

            <button *ngIf="(userPermissions | async)?.newsletter.write" [disabled]="!(userPermissions | async)?.newsletter.write"  [routerLink]="['/newsletter/szczegoly', element.uuid]" (click)="editNewsletter(element)" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
            <button *ngIf="(userPermissions | async)?.newsletter.delete" [disabled]="!(userPermissions | async).document.delete" (click)="deleteNewsletter(element)" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>

          </div>
        </td>
      </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
